import { ReactNode, memo } from 'react';
import s from './Modal.module.scss';
import { ReactComponent as Cross } from 'images/cross.svg';
import { Button } from '../Button';
import { ReactComponent as ArrowBack } from 'images/arrowBack.svg';

const icons = {
  cross: <Cross />,
  back: <ArrowBack />,
};

type ModalProps = {
  children: ReactNode;
  className?: string;
  title?: ReactNode;
  onClose?: React.MouseEventHandler<HTMLElement>;
  onBack?: React.MouseEventHandler<HTMLElement>;
};

export const Modal = memo(
  ({ children, className, title = '', onClose, onBack }: ModalProps) => {
    return (
      <div
        className={s.container}
        onMouseDown={(e) => {
          e.stopPropagation();
          if (e.target === e.currentTarget) onClose?.(e);
        }}
      >
        <div className={`${s.window} ${className ?? ''}`}>
          <div className={s.header}>
            {onBack ? (
              <Button className={s.nav_btn} onClick={onBack}>
                {icons.back}
              </Button>
            ) : (
              <div />
            )}

            <h2>{title}</h2>

            {onClose ? (
              <Button className={s.nav_btn} onClick={onClose}>
                {icons.cross}
              </Button>
            ) : (
              <div />
            )}
          </div>

          {children}
        </div>
      </div>
    );
  },
);

Modal.displayName = 'Modal';
